module.exports = __webpack_public_path__ + "img/11825397_L.343cc7bc.png";